module.exports = "<div class=\"content ripple bg-secondary\" [ngStyle]=\"{ 'width.px': size, 'height.px': size }\">\n  <span [ngStyle]=\"{ 'font-size.em' : (size / 20) }\">\n    {{ value$ | async | uppercase }}\n  </span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/core/avatar/avatar.component.html
// module id = 1089
// module chunks = 0